export const isValidRecord = (record) => {
  return !!record.get('scanMeasurement') && !!record.get('wellnessMetrics')
}

export const getValidRecord = (records) => {
  return records.find((record) => isValidRecord(record))
}
